import Modal from "components/Modal";
import { SignatureInput } from "components/SignatureInput";
type Props = {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  onSubmit: (signature: string | null) => void;
  isPending?: boolean;
  existingSignatureInBase64?: string | null; // base64 PNG data URL
};
export const SignatureModal = ({
  isOpen,
  title,
  onClose,
  onSubmit,
  isPending,
  existingSignatureInBase64,
}: Props) => {
  return (
    <Modal isOpen={isOpen} title={title} onClose={onClose} hideButtons>
      <SignatureInput
        sendImageToParent={onSubmit}
        cancel={onClose}
        isLoading={isPending}
        existingSignatureInBase64={existingSignatureInBase64}
      />
    </Modal>
  );
};
